module.exports = __webpack_public_path__ + "static/media/veggie_interaction_map-2.313be3ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/food/veggie_interaction_map-2.jpg
// module id = 88
// module chunks = 0